<template>
  <div style="overflow-x:hidden ">
    <NavHeader
      :status="{
        page:'about',
        produce:false,
        solution:false
      }"
    />
    <div class="main"
         ref="aboutus">
      <div class="aboutus-color-back"></div>
      <div class="aboutus-back"></div>
      <div class="title-back"> <h1 style="margin-top: 5vw;text-align: center; line-height: 4vw;">关于我们</h1></div>

      <p style="width: 60vw;margin: 2vw auto 3vw;font-size: 0.8vw;line-height: 2vw">
        <span style="font-weight: 800;font-size: 1vw">
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;广州摩翼信息科技有限公司(翼课网)，
        </span>
        成立于2014年,是一家全面贯彻国家教育信息化发展战路、服务于中小学基础教育信息化发展，在国家重点支持的高新技术领域内拥有核心自主知识产权，并具备持续研究开发与技术成果转化能力的高新技术企业。<br>&nbsp;&nbsp;&nbsp;&nbsp;
        公司聚焦基础教育领域学习个性化、考试智能化、教研信息化三大核心教育科技需求，研发出支持教师开展分层教学、学生实现个性化自适应学习的智慧化学与教平台，满足中高考人机交互场景的智能化考试系统，赋能教师专业成长的全国中小学教师网络研修平台等核心支柱产品。
      </p>
<!--      <div >-->
<!--        <div style="width: 60vw;height: 25vw;margin: 0 auto" class="aboutus-img1"></div>-->
<!--      </div>-->
      <div class="title-back"> <h1 style="margin: 10vw auto 10vw;text-align: center; line-height: 4vw;">招兵买马</h1></div>

      <div style="position: relative;width: 100vw;height: 65vw;margin-top: 5vw">
        <div class="aboutus-male"></div>



        <div
          style="
          width: 20vw;
          height: 2vw;
          font-size: 2.5vw;
          color: #250072;
          font-weight: 1000;
          line-height: 2vw;
          margin: 1vw auto;
          text-align: center;
          position: absolute;
          top:4vw;
          right:19vw;
          z-index: 100">
          U3D开发工程师
        </div>
        <div class="aboutus-card" style="top:4vw;left: 60vw;z-index: 10;">

          <div style="display: flex;margin: 5vw auto 2vw;width: 20vw;height: 2vw">
            <div style="font-size: 1vw;background-color: #d3dce6;border-radius: 2vw;line-height: 2vw;text-align: center;width: 5vw;">
              西安
            </div>
            <div style="font-size: 1vw;background-color: #d3dce6;border-radius: 2vw;line-height: 2vw;text-align: center;width: 8vw;margin: 0 auto">
              经验1-3年
            </div>
            <div style="font-size: 1vw;background-color: #d3dce6;border-radius: 2vw;line-height: 2vw;text-align: center;width: 5vw;">
              本科
            </div>
          </div>
          <div >
            <span style="font-size:1.2em;font-weight: 600 ;margin-bottom: 0.5vw;display: inline-block;margin-left: 2vw">
              岗位要求：
            </span>
            <p class="aboutus-card-text">
              ·熟悉C#编程语言,熟悉项目制作规范;<br>
              ·熟悉Unity3D引擎架构;<br>
              ·熟悉开发中常用的数据结构和算法;<br>
              ·熟悉3dmax,maya等建模软件,属性Unity3D交互式开发;
            </p>
          </div>
          <div class="aboutus-btn">
          </div>
        </div>


        <div class="aboutus-card" style="  top:24vw;left: 20vw;">
          <div style="width: 20vw;height: 2vw;font-size: 2.5vw;color: #250072;font-weight: 1000;line-height: 2vw;margin: 1vw auto;text-align: center">
            3D建模工程师
          </div>
          <div style="display: flex;margin: 2vw auto 2vw;width: 20vw;height: 2vw">
            <div style="font-size: 1vw;background-color: #d3dce6;border-radius: 2vw;line-height: 2vw;text-align: center;width: 5vw;">
              西安
            </div>
            <div style="font-size: 1vw;background-color: #d3dce6;border-radius: 2vw;line-height: 2vw;text-align: center;width: 8vw;margin: 0 auto">
              经验1-3年
            </div>
            <div style="font-size: 1vw;background-color: #d3dce6;border-radius: 2vw;line-height: 2vw;text-align: center;width: 5vw;">
              本科
            </div>
          </div>
          <div >
            <span style="font-size:1.2em;font-weight: 600 ;margin-bottom: 0.5vw;display: inline-block;margin-left: 2vw">
              岗位要求：
            </span>
            <p class="aboutus-card-text">
              ·熟练使用3Dmax或MAYA、Zbrush等建模软件制作模型;<br>
              ·熟练使用Substance Painter或Substance designer或其他贴图制作软件进行pbr贴图制作;<br>
              ·与unity3D引擎进行无缝对接;
            </p>
          </div>
          <div class="aboutus-btn">
          </div>
        </div>


        <div class="aboutus-female"></div>
        <div class="aboutus-card" style="top:40vw;left: 50vw;z-index: 1">
          <div style="width: 20vw;height: 2vw;font-size: 2.5vw;color: #250072;font-weight: 1000;line-height: 2vw;margin: 1vw auto;text-align: center">
            产品专员
          </div>
          <div style="display: flex;margin: 2vw auto 2vw;width: 20vw;height: 2vw">
            <div style="font-size: 1vw;background-color: #d3dce6;border-radius: 2vw;line-height: 2vw;text-align: center;width: 5vw;">
              西安
            </div>
            <div style="font-size: 1vw;background-color: #d3dce6;border-radius: 2vw;line-height: 2vw;text-align: center;width: 8vw;margin: 0 auto">
              经验1-3年
            </div>
            <div style="font-size: 1vw;background-color: #d3dce6;border-radius: 2vw;line-height: 2vw;text-align: center;width: 5vw;">
              本科
            </div>
          </div>
          <div >
            <span style="font-size:1.2em;font-weight: 600 ;margin-bottom: 0.5vw;display: inline-block;margin-left: 2vw">
              岗位要求：
            </span>
            <p class="aboutus-card-text">
              ·熟练使用OFFICE办公软件;<br>
              ·有较好的沟通技巧和工作安排能力;<br>
              ·熟悉SNS产品设计，熟练使用Axure等常用产品设计工具;<br>
              ·对市场发展趋势有敏锐的洞察力和创新意识;
            </p>
          </div>
          <div class="aboutus-btn">
          </div>
        </div>
      </div>
      <section style="margin: 5vw auto 0.1vw;width: 100vw;height: 35vw">
        <no-ssr>
          <el-amap class="amap-box" :zoom="zoom" :center="center"  :vid="'amap-vue'">
            <el-amap-circle
              v-for="(circle,index) in circles"
              :key="index"
              :center="circle.center"
              :radius="circle.radius"
              :fill-opacity="circle.fillOpacity"
              :events="circle.events"
              fill-color="red"></el-amap-circle>
          </el-amap>
        </no-ssr>
      </section>
      <div class="footer-img">
        <div style="font-family: test;font-size: 1.2vw;color: white;font-weight: 100;cursor: default">让我们一起育见未来</div>
        <div class="footer-btn-group">
          <div class="footer-btn">立即试用</div>
        </div>
      </div>
    </div>
    <Footer/>
  </div>

</template>

<script>
import NavHeader from '@/components/NavHeader'
import Footer from '@/components/Footer'
export default {
  name: 'aboutUS',
  components: { NavHeader,Footer },
  data(){
    return{
      zoom: 18,
      center: [108.85834504578398, 34.15663082508158],
      circles: [
        {
          center: [108.85834504578398, 34.15663082508158],
          radius: 10,
          fillOpacity: 0.5,
          events: {
            click: () => {
              alert('click');
            }
          }
        }
      ]
    }
  }
}
</script>

<style scoped>



p {
  font-family: "Microsoft YaHei UI Light";
  line-height: 2rem;
  letter-spacing: 1px;
}


.header {
  position: relative;
  width: 100vw;
  height: 42vh;
}

.main {
  width: 100vw;
  margin-top: 25vw;
  margin-bottom: 0;
  position: relative;

}



@media screen and (max-width: 1200px) {

  .aboutus-card-text{
    width: 18vw;
    text-align: left;
    margin: 0 auto;
    font-size: 10px;
    line-height: 0.2vw;
  }

}
.title-back{
  background-image: url("http://data.xiyilab.com/web/main/static/首页/标题背景.png");
  width: 100vw;
  height: 4vw;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  margin: auto;
  white-space: nowrap;
  text-align: center;

}
.footer-img{
  height: 5vw;
  width: 100vw;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  background-image: url("http://data.xiyilab.com/web/main/static/首页/连接商业价值，融合价值创新.png");
}
.aboutus-color-back{
  position: absolute;
  width: 100vw;
  height: 55vw;
  top:10vw;
  left: 0;
  z-index: -1;
  background-image: url("http://data.xiyilab.com/web/main/static/关于我们/橙色背景装饰.png");
  background-repeat: no-repeat;
  background-position: left;
  background-size: 100% 100%;
}

.aboutus-back{
  position: absolute;
  width: 100vw;
  height: 50vw;
  top:30vw;
  left: 2vw;
  z-index: -1;
  background-image: url("http://data.xiyilab.com/web/main/static/关于我们/矢量背景.png");
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
}
.aboutus-male{
  position: absolute;
  width: 15vw;
  height: 29vw;
  top:0vw;
  left: 50vw;
  z-index: 20;
  background-image: url("http://data.xiyilab.com/web/main/static/关于我们/男.png");
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
}
.aboutus-female{
  position: absolute;
  width: 15vw;
  height: 29vw;
  top:36vw;
  right: 19vw;
  z-index: 10;
  background-image: url("http://data.xiyilab.com/web/main/static/关于我们/女.png");
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
}


.aboutus-btn{
  background-image: url("http://data.xiyilab.com/web/main/static/关于我们/联系我们拷贝.png");
  width:8vw;
  height: 4vw;
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
  margin:0 auto;
}
.aboutus-btn:hover{
  background-image: url("http://data.xiyilab.com/web/main/static/关于我们/联系我们.png");
}
.aboutus-card{
  position: absolute;
  width: 22vw;
  max-height: 30vw;
  box-shadow:0px 3px 3px #c8c8c8 ;
}
.aboutus-card-text{
  width: 18vw;
  text-align: left;
  margin: 0 auto;
  font-size: 0.8vw;
  line-height: 1.6vw;

}
.footer-img{
  width: 100vw;
  height: 9vw;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-image: url("http://data.xiyilab.com/web/main/static/首页/育见未来.png");
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.footer-btn-group{
  margin-top: 2vw;
  width: 30vw;
  height: 1.8vw;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-around;
}
.footer-btn{
  width: 6vw;
  font-weight: 100;
  font-size: 0.8vw;
  font-family: test;
  border: 1px white solid;
  color: white;
  background: transparent;
  line-height:1.8vw;
  text-align: center;
  cursor: pointer;
}
</style>
